import { Box, Typography } from '@mui/material';
import { memo, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';

export const DefaultWaitingScreen = memo(function ({ text }: { text?: string }): ReactElement {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
      }}
    >
      <HourglassEmptyOutlinedIcon fontSize='small' />
      {text && (
        <Typography variant='body2' sx={{ textAlign: 'center' }}>
          {t(text)}
        </Typography>
      )}
    </Box>
  );
});
